import React from 'react';
import { Chart, Tooltip, Geom, Legend, Axis } from 'bizcharts';
import DataSet from '@antv/data-set';
import Slider from 'bizcharts-plugin-slider';
import styles from './index.less';

class TimelineChart2 extends React.Component {
  render() {
    const {
      title,
      height = 400,
      padding = [20, 20, 40, 60],
      titleMap = {
        y1: 'y1',
      },
      borderWidth = 2,
      data: sourceData,
      yCount = 1,
    } = this.props;

    const data = Array.isArray(sourceData) ? sourceData : [{ x: 0, y1: 0, y2: 0, y3: 0, y4: 0, y5: 0, y6: 0 }];

    data.sort((a, b) => a.x - b.x);

    let max;
    if (data[0] && data[0].y1) {
      max = Math.max(
        [...data].sort((a, b) => b.y1 - a.y1)[0].y1
      );
      for (let i = 2; i <= yCount; i++) {
        max = Math.max(max, [...data].sort((a, b) => b['y' + i] - a['y' + i])[0]['y' + i]);
      }
    }

    const ds = new DataSet({
      state: {
        start: data[0] ? data[0].x : 0,
        end: data.length > 0 ? data[data.length - 1].x : 0,
      },
    });

    const fields = [];
    for (let i = 1; i <= yCount; i++) {
      fields.push(titleMap['y' + i]);
    }
    const dv = ds.createView();
    dv.source(data)
      .transform({
        type: 'filter',
        callback: obj => {
          const date = obj.x;
          return date <= ds.state.end && date >= ds.state.start;
        },
      })
      .transform({
        type: 'map',
        callback(row) {
          const newRow = { ...row };
          for (let i = 1; i <= yCount; i++) {
            newRow[titleMap['y' + i]] = row['y' + i];
          }

          return newRow;
        },
      })
      .transform({
        type: 'fold',
        fields: fields,
        key: 'key', // key字段
        value: 'value', // value字段
      });

    const timeScale = {
      type: 'time',
      tickInterval: 60 * 60 * 1000,
      mask: 'HH:mm',
      range: [0, 1],
    };

    const cols = {
      x: timeScale,
      value: {
        max,
        min: 0,
      },
    };

    const SliderGen = () => (
      <Slider
        padding={[0, padding[1] + 20, 0, padding[3]]}
        width="auto"
        height={26}
        xAxis="x"
        yAxis="y1"
        scales={{ x: timeScale }}
        data={data}
        start={ds.state.start}
        end={ds.state.end}
        backgroundChart={{ type: 'line' }}
        onChange={({ startValue, endValue }) => {
          ds.setState('start', startValue);
          ds.setState('end', endValue);
        }}
      />
    );

    return (
      <div className={styles.timelineChart} style={{ height: height + 30 }}>
        <div>
          {title && <h4>{title}</h4>}

          <Chart height={height} padding={padding} data={dv} scale={cols} forceFit style={{ direction: "ltr" }}>

            <Axis name="x" />

            <Tooltip />

            <Legend name="key" position="top" />

            <Geom type="line" position="x*value" size={borderWidth} color="key" />

          </Chart>
          <div style={{ marginRight: -20 }}>
            <SliderGen />
          </div>
        </div>
      </div>
    );
  }
}

export default TimelineChart2;
